import { Component, OnInit } from '@angular/core';
import { AuthAmplifyService } from 'src/app/shared/service/auth-amplify.service';
import { Auth } from "aws-amplify";
import { Router } from '@angular/router';

@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.scss']
})
export class AuthenticateComponent implements OnInit {

  auth = Auth;
  isLoggedInUser = false;
  loggedInUserData: any;

  constructor(private readonly authService: AuthAmplifyService, private readonly router: Router) { }

  ngOnInit(): void {
    localStorage.clear();
    this.proxyLogin();
  }

  proxyLogin() {
    this.authService.proxyLogin().subscribe(response => {
      this.navigate(response.data);
      localStorage.setItem('loggedIn', 'true')
    });
  }

  navigate(url: string) {
    window.location.assign(url);
}

  login() {
    this.authService.signIn();
  }

}